export default "__VITE_ASSET__DiTirVMG__"